import React from 'react';
import { Tooltip } from 'antd';
import cn from 'classnames';
import { useActions } from '../../model/state';
import { useCanChangePaymentState } from '../../model/globalState';
import { methods, stateKeys, typeKeys, types } from '../../config/invoiceBlock';
import PaidContent from './PaidContent';
import NotPaidContent from './NotPaidContent';
import IconFactory from './IconFactory';
import styles from './InvoiceBlock.module.scss';

const isInteractive = ({
  canChange,
  canChangePaymentState,
  isPaid,
  isFinal,
}) => {
  if (canChange && !isFinal) return true;

  if (canChange && isFinal && !isPaid) return canChangePaymentState;

  return false;
};

const renderContent = (isPaid, props) => {
  const { paymentState, amount, paidTime, type, sum, isFinal } = props;

  if (isPaid) {
    return (
      <PaidContent
        paymentState={paymentState}
        amount={amount}
        paidTime={paidTime}
      />
    );
  }

  return (
    <NotPaidContent
      type={type}
      sum={sum}
      isFinal={isFinal}
      paymentState={paymentState}
    />
  );
};

const InvoiceBlock = ({
  type,
  request,
  className,
  canChange = true,
  ...props
}) => {
  const canChangePaymentState = useCanChangePaymentState();

  const validType = types.has(type) ? type : typeKeys.requestsPage;

  const { invoice } = request;
  const { paymentState, amount, paidTime, sum, isFinal, paymentType } =
    invoice || {};

  const { onInvoiceBlockClick } = useActions();

  const state = methods.getState({ invoice });
  const isPaid = state === stateKeys.paid;

  const interactive = isInteractive({
    canChange,
    canChangePaymentState,
    isPaid,
    isFinal,
  });

  const handleClick = interactive
    ? (e) => {
        e.stopPropagation();
        onInvoiceBlockClick(request);
      }
    : undefined;

  const Container = interactive ? 'button' : 'span';

  const tTitle = methods.getTooltipTitle(paymentType);

  return (
    <Tooltip title={isFinal ? `${tTitle}` : ''}>
      <Container
        {...props}
        onClick={handleClick}
        className={cn(
          styles.root,
          styles[validType],
          styles[state],
          className,
          { [styles.active]: interactive }
        )}
      >
        <IconFactory paymentTypeId={paymentType?.id} />
        <span className={styles.invoiceWrap}>
          {renderContent(isPaid, {
            paymentState,
            amount,
            paidTime,
            type: validType,
            sum,
            isFinal,
          })}
        </span>
      </Container>
    </Tooltip>
  );
};

export default InvoiceBlock;
